/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Resetfilter1Inputs */

const de__filter_resetfilter1 = /** @type {(inputs: _Filter_Resetfilter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter zurücksetzen`)
};

/**

* @param {_Filter_Resetfilter1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_resetfilter1 = /** @type {((inputs?: _Filter_Resetfilter1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Resetfilter1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_resetfilter1(inputs)
});
export { _filter_resetfilter1 as "_filter_resetFilter" }